import { render, staticRenderFns } from "./AdminClientWorkspacesForm.vue?vue&type=template&id=6eef9d65"
import script from "./AdminClientWorkspacesForm.vue?vue&type=script&lang=ts"
export * from "./AdminClientWorkspacesForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports